import { type ChangeEvent } from 'react'

import { TextArea } from '@/shared'

import style from './EditFeedback.module.scss'

interface IProps {
    content: string
    isEdit: boolean
    onEnter: () => void
    onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
}

export const EditFeedback = (props: IProps) => {
    const { content, isEdit, onChange, onEnter } = props
    return (
        <div className={style.container}>
            <TextArea value={content} onChange={onChange} onEnter={onEnter} disabled={!isEdit} />
        </div>
    )
}
